import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../../utils/globals/data'

interface WorkSheetGroupStatusSortButtonProps extends BaseButtonModalSortListProps {
}

const WorkSheetGroupStatusSortButton: React.FC<WorkSheetGroupStatusSortButtonProps> = ({ ...rest }) => {
    const { updateWorkSheetProduct } = useWorkSheetGroupStatusSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateWorkSheetProduct} getDataFrom='/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetgroupStatuses' {...rest} />
    )
}

const useWorkSheetGroupStatusSortButtonLogic = () => {
    const updateWorkSheetProduct: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/order/sell/workSheet/workSheetGroupStatus/updateWorkSheetGroupStatusOrder', { workSheetGroupStatuses: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateWorkSheetProduct }
}

export default WorkSheetGroupStatusSortButton